import { render, staticRenderFns } from "./AdditionalUnderwritingData.vue?vue&type=template&id=38074c9d&scoped=true&"
import script from "./AdditionalUnderwritingData.vue?vue&type=script&lang=js&"
export * from "./AdditionalUnderwritingData.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalUnderwritingData.vue?vue&type=style&index=0&id=38074c9d&prod&lang=scss&scoped=true&"
import style1 from "../../../node_modules/v-calendar/lib/v-calendar.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38074c9d",
  null
  
)

export default component.exports